import moment from 'jalali-moment';
import React, {Component} from "react";
import {Col, Image} from "react-bootstrap";

class Auction extends Component {
    render() {
        let auction_url = "/auction-detail/" + this.props.data.id ;

        const start_date = moment(this.props.data.start_date, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');

        const end_date = moment(this.props.data.end_date, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');

        const auction_image = (this.props.data.attachments) && !this.props.data.attachments.includes("default.jpg") ?
            this.props.data.attachments :
            process.env.REACT_APP_BASE_URL + "/images/default/auction.jpg";

        return (
            <Col md={6} className="items web info-overlay mb-50">
                <div className="item-img o-hidden">
                    <a href={auction_url}>
                        <div className="imago wow">
                            <div className="inner wow">
                                <Image src={auction_image} alt="image"/>
                            </div>
                        </div>
                        <div className="info">
                            <h6 className="sub-title tag">
                                آغاز: {start_date} <br/>پایان: {end_date}
                            </h6>
                            <h5>{this.props.data.title}</h5>
                        </div>
                        <div className="init-info">
                            <h5>مزایده شماره {this.props.data.code}</h5>
                        </div>
                    </a>
                </div>
            </Col>
        );
    }
}

export default Auction;
